import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getSubscriptionPayments = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/subscription-payments/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Subscription payments fetch error:", error);
    throw error;
  }
};

export { getSubscriptionPayments };
